export enum DocumentType {
  //ID = "ID_CARD",
  //Passport = "PASSPORT",
  ResidencePermit = "RESIDENCE_PERMIT",
  InternationalPassport = "INTERNATIONAL_PASSPORT",
  DriverLicense = "DRIVER_LICENSE",
}

export enum Sex {
  M = "M",
  F = "F",
}

export enum KYCStatus {
  NotVerified = "NOT_VERIFIED",
  InVerification = "IN_VERIFICATION",
  ManualReview = "MANUAL_REVIEW",
  Ok = "OK",
}

export interface PublisherProfile {
  email: string
  name: null | string
  surname: null | string
  phone: null | string
  lang: null | string
  id: number
  birthday_date: null | string
  document_country_code: null | string
  document_expiration_date: null | string
  document_issuance_date: null | string
  tax_number: null | string
  nationality_country_code: null | string
  document_number: null | string
  document_type: null | DocumentType
  sex: null | Sex
  address: null | string
  kyc_status: KYCStatus
  kyc_status_translated: string
}

export interface StartKYCVerificationResponse {
  next_action: "iframe"
  iframe_uri: string
}
